export default "__VITE_ASSET__C904L1Je__"